import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getSuccessToast } from "../../toast";
import "./UserCard.css";
import { ReactSession } from "react-client-session";

const UserCard = () => {
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const username = ReactSession.get("username");
  // const { setIsFormOpen } = useContext(FormContext);

  const logoutHandler = () => {
    try {
      axiosPrivate
        .post("/auth/logout", {
          username: ReactSession.get("username"),
          refresh: ReactSession.get("refreshToken"),
        })
        .then(() => {
          // setIsFormOpen(false);
          ReactSession.remove("accessToken");
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
          getSuccessToast("Logged out successfully", 1000);
        });
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="user-card-container">
      <p className="user-card-name">{username}</p>
      <section className="user-card-logout-button-section">
        <button
          className="button user-card-logout-button"
          onClick={logoutHandler}
        >
          LOGOUT
        </button>
      </section>
    </div>
  );
};

export default UserCard;
